import { IIsComponent } from '@ic-builder/is-base';

export class SetCurrentFormDefinition {
  public static readonly type = '[FormDefinition.SetCurrentFormDefinition]';
  constructor(public payload: IIsComponent) {}
}

export class NewCurrentFormDefinition {
  public static readonly type = '[FormDefinition.NewCurrentFormDefinition]';
  constructor(public payload: IIsComponent) {}
}

export class AddWidget {
  public static readonly type = '[FormDefinition.AddNewWidget]';
  constructor(public payload: { widget: IIsComponent; parentId: number }) {
    // console.trace(
    //   `%cClass: AddWidget, Function: constructor(payload): `,
    //   'color: black;',
    //   payload
    // );
  }
}

export class AddedWidget {
  public static readonly type = '[FormDefinition.AddedNewWidget]';
  constructor(public payload: { widget: IIsComponent; parentId: number }) {
    // console.trace(
    //   `%cClass: AddedWidget, Function: constructor(payload): `,
    //   'color: black;',
    //   payload
    // );
  }
}

export class DeleteWidget {
  public static readonly type = '[FormDefinition.DeleteWidget]';
  constructor(public payload: number) {}
}
export class DeletedWidget {
  public static readonly type = '[FormDefinition.DeletedWidget]';
  constructor(public payload: { id: number; parentId: number }) {}
}

export class UpdateWidgetPath {
  public static readonly type = '[FormDefinition.UpdateWidgetPath]';
  constructor(public payload: { id: number; path: string[]; value: unknown }) {}
}

export class DeleteWidgetPath {
  public static readonly type = '[FormDefinition.DeleteWidgetPath]';
  constructor(public payload: { id: number; path: string[] }) {}
}

export class CopyWidget {
  public static readonly type = '[FormDefinition.CopyWidget]';
  constructor(public payload: number) {}
}

export class CutWidget {
  public static readonly type = '[FormDefinition.CutWidget]';
  constructor(public payload: number) {}
}

/**
 * pastes the widget into the parent with id === payload
 */
export class PasteWidget {
  public static readonly type = '[FormDefinition.PasteWidget]';
  constructor(public payload: number) {}
}

export class SetSelectedElementId {
  public static readonly type = '[FormDefinition.SetSelectedElementId]';
  constructor(public payload: number | undefined) {}
}

export class SaveWidget {
  static readonly type = '[SaveWidget]';
}
